module.exports = __webpack_public_path__ + "img/menu.9f4a6aad.svg";